<template>
  <table class="t-table">
    <thead>
      <tr>
        <td width="20%">{{ $t('table.columns.tournament') }}</td>
        <td width="30%">{{ $t('table.columns.playerName') }}</td>
        <td width="25%">{{ $t('table.columns.score') }}</td>
        <td width="25%" class="t-table-data">
          <div>
            {{ $t('table.columns.ticket') }}
            <t-tooltip class="tooltip" :text="$t('table.info.ticket')">
              <i class="icf-info" />
            </t-tooltip>
          </div>
        </td>
      </tr>
    </thead>
    <tbody>
      <template v-if="data.length > 0">
        <template v-for="(tournament, tindex) in data">
          <template v-if="tournament.seasonRankings.length > 0">
            <tr
              v-for="(user, uindex) in tournament.seasonRankings"
              :class="{ 'table-row-odd': tindex % 2 }"
              :key="user.playerId"
              :data-qe-id="`tr-data--tournament_${tindex}--user_${uindex}${isMyUser(user) ? '--highlighted' : ''}`"
            >
              <td v-if="uindex === 0" :rowspan="tournament.seasonRankings.length">{{ tournament.tournamentName }}</td>
              <td :class="{ highlighted: isMyUser(user) }" data-qe-id="playername">{{ user.playerName }}</td>
              <td :class="{ highlighted: isMyUser(user) }" data-qe-id="score">{{ user.ticketInfo.tournamentScore }}</td>
              <td :class="{ highlighted: isMyUser(user) }">
                <c-ticket-icon />
              </td>
            </tr>
          </template>
        </template>
        <tr v-if="maxRows > data.length">
          <td class="show-more-row" :colspan="COLSPAN_NUM" @click="onShowMore" data-qe-id="show-more-link">
            {{ $t('table.more.button') }} <i class="icf-arrowBottom"></i>
          </td>
        </tr>
        <tr v-if="isSearchActive && data.length === 0">
          <td :colspan="COLSPAN_NUM">
            {{ $t('table.search.results_not_found') }}
          </td>
        </tr>
      </template>
      <template v-else>
        <tr class="no-results" data-qe-id="no-results-available-row">
          <td :colspan="COLSPAN_NUM">{{ $t('table.more.no_results') }}</td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script setup lang="ts">
import { TicketGroup } from '@/store/modules/ranking/season'
import { SeasonRanking } from '@/model/ranking/Season'
import CTicketIcon from '@/components/CTicketIcon.vue'

const props = defineProps<{
  data: Array<TicketGroup>
  maxRows: number
  myRank: SeasonRanking
  isSearchActive: boolean
}>()
const emit = defineEmits(['show-more'])
const COLSPAN_NUM = 4

function isMyUser(user: SeasonRanking) {
  return user.playerId === props.myRank.playerId
}

function onShowMore() {
  emit('show-more')
}
</script>

<style lang="less" scoped></style>
